<div class="container" id="container" *ngIf="finishedLoading">

    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Ummeldung </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="infoForm">
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Status:</mat-label>
                                <input matInput type="text" formControlName="state">
                                <mat-error *ngIf="infoForm.get('state').hasError('required')">
                                    Status <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Ersteller:</mat-label>
                                <input matInput type="text" formControlName="creator">
                                <mat-error *ngIf="infoForm.get('creator').hasError('required')">
                                    Ersteller <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Erstellt am:</mat-label>
                                <input matInput type="date" formControlName="created">
                                <mat-error *ngIf="infoForm.get('created').hasError('required')">
                                    Erstellt am <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>

                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Letzte Änderung:</mat-label>
                                <input matInput type="date" formControlName="lastModified">
                                <mat-error *ngIf="infoForm.get('lastModified').hasError('required')">
                                    Letzte Änderung am <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>

                        </div>

                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Meine persönlichen Angaben </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row" [formGroup]="personFrom">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Vorname:</mat-label>
                                <input matInput type="text" formControlName="firstName">
                                <mat-error *ngIf="personFrom.get('firstName').hasError('required')">
                                    Vorname <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Nachname:</mat-label>
                                <input matInput type="text" formControlName="lastName">
                                <mat-error *ngIf="personFrom.get('lastName').hasError('required')">
                                    Vorname <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row" [formGroup]="contactForm">
                        <div class="col-sm-3">
                            <mat-form-field class="full-width">
                                <mat-label>Telefon:</mat-label>
                                <input matInput type="number" formControlName="phone">
                                <mat-error *ngIf="contactForm.get('phone').hasError('required')">
                                    Telefon <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-3">
                            <mat-form-field class="full-width">
                                <mat-label>Telefon mobil:</mat-label>
                                <input matInput type="number" formControlName="phoneMobile">
                                <mat-error *ngIf="contactForm.get('phoneMobile').hasError('required')">
                                    Telefon mobil <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>E-Mail:</mat-label>
                                <input matInput type="text" formControlName="email">
                                <mat-error *ngIf="contactForm.get('email').hasError('required')">
                                    E-Mail <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Vertragsdaten </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="addressFrom">
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Kundennummer:</mat-label>
                                <input matInput type="text" formControlName="supplyContract">
                                <mat-error *ngIf="addressFrom.get('supplyContract').hasError('required')">
                                    Kundennummer <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Verbrauchstellennummer:</mat-label>
                                <input matInput type="text" formControlName="consumptionNumber">
                                <mat-error *ngIf="addressFrom.get('consumptionNumber').hasError('required')">
                                    Verbrauchstellennummer <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <h5>Ihre bisherige Anschrift</h5>
                            <div class="row">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Strasse:</mat-label>
                                        <input matInput type="text" formControlName="street">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Postleitzahl:</mat-label>
                                        <input matInput type="number" formControlName="postcode">
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Ort:</mat-label>
                                        <input matInput type="text" formControlName="city">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <h5>Ihre neue Anschrift</h5>
                            <div class="row">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Strasse:</mat-label>
                                        <input matInput type="text" formControlName="newAddressStreet">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Postleitzahl:</mat-label>
                                        <input matInput type="number" formControlName="newAddressPostcode">
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Ort:</mat-label>
                                        <input matInput type="text" formControlName="newAddressCity">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>


    <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Mein Vertragsbeginn/-ende </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="dateForm">
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Vertragsende für die alte Anschrift:</mat-label>
                                <input matInput type="number" formControlName="terminationDateOldAddress">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Vertragsbeginn für die neue Anschrift:</mat-label>
                                <input matInput type="text" formControlName="keyHandoverDateNewAddress">
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>


    <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Eigentümer </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="ownerForm">
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Anrede:</mat-label>
                                <input matInput type="number" formControlName="gender">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Titel:</mat-label>
                                <input matInput type="text" formControlName="title">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Vorname:</mat-label>
                                <input matInput type="number" formControlName="firstName">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Nachname:</mat-label>
                                <input matInput type="text" formControlName="lastName">
                            </mat-form-field>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Strasse:</mat-label>
                                <input matInput type="text" formControlName="street">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Postleitzahl:</mat-label>
                                <input matInput type="number" formControlName="postcode">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Ort:</mat-label>
                                <input matInput type="text" formControlName="city">
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title> Vor/Nachmieter </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="ownerForm">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Anrede:</mat-label>
                                <input matInput type="number" formControlName="gender">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Vorname:</mat-label>
                                <input matInput type="number" formControlName="firstName">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Nachname:</mat-label>
                                <input matInput type="number" formControlName="lastName">
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <!-- <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card class="example-card">
                <mat-card-header>
                    <mat-card-title> Meine alten Zählerstände </mat-card-title>
                </mat-card-header>
                <mat-card-content >

                </mat-card-content>
            </mat-card>
        </div>
    </div> -->


    <div class="row marginTop2Rem" >
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <div class="actionRow mat-elevation-z2">
                <table mat-table [dataSource]="dataSourceOldMeasuredValues" class="mat-elevation-z2">
                    <ng-container matColumnDef="count">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
                            {{i+1}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="measuredAt">
                        <th mat-header-cell *matHeaderCellDef >
                            Ablesedatum
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.measuredAt}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            Zählernummer
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.number}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>
                            Versorgungsart
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.type}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef >
                            Zählerstand HT
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="valueNT">
                        <th mat-header-cell *matHeaderCellDef >
                            Zählerstand NT
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.valueNT}}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                </table>
<!-- 
                <span *ngIf="dataSourceOldMeasuredValues?.data.length === 0"
                    class="emptyTableState  mat-elevation-z2">Keine
                    passenden
                    Einträge
                    gefunden...</span> -->
            </div>
        </div>
    </div>

    <div class="row marginTop2Rem" >
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <div class="actionRow mat-elevation-z2">
                <table mat-table [dataSource]="dataSourceNewMeasuredValues" class="mat-elevation-z2">
                    <ng-container matColumnDef="count">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
                            {{i+1}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="measuredAt">
                        <th mat-header-cell *matHeaderCellDef >
                            Ablesedatum
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.measuredAt}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            Zählernummer
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.number}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>
                            Versorgungsart
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.type}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef >
                            Zählerstand HT
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="valueNT">
                        <th mat-header-cell *matHeaderCellDef >
                            Zählerstand NT
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.valueNT}}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                </table>

                <span *ngIf="dataSourceNewMeasuredValues?.data.length === 0"
                    class="emptyTableState  mat-elevation-z2">Keine
                    passenden
                    Einträge
                    gefunden...</span> 
            </div>
        </div>

        <div class="row marginTop2Rem marginBottom2Rem">
            <div class="offset-lg-2 col-lg-8 offset-lg-2">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <mat-card-title>Möchten Sie uns noch etwas mitteilen?
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content [formGroup]="commentForm">
                        <div class="row">
                            <div class="col-sm-12">
                                <mat-form-field class="full-width">
                                    <textarea matInput formControlName="comment" rows="8" cols="50"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>

    </div>


    <div class="container" id="container" *ngIf="!finishedLoading">
        <div class="row">
            <div class="col-sm-12 padding">
                <div class="loadingOverlay">
                    <mat-spinner></mat-spinner>
                </div>
            </div>
        </div>
    </div>